import { action, makeObservable, observable } from 'mobx';

import { IApiClient } from '../../../../app/data/client';
import Logger from '../../../../app/shared/Logger';
import type { PricelistProductFamilyData, PricelistProductFamilyDetailsData, PricingContext } from '../../../model';
import { GetProductFamilyDetailsQuery } from '../../../queries';

export class ProductFamilyDetailsState {
  @observable.ref
  public data: PricelistProductFamilyDetailsData;

  @observable
  public isLoading = true;

  public constructor(
    private readonly client: IApiClient,
    private readonly pricingContext: PricingContext,
    family: PricelistProductFamilyData,
  ) {
    makeObservable(this);

    this.data = {
      id: family.id,
      name: family.name,
      brandId: family.brandId,
      brandName: family.brandName,
      image: family.image,
      description: '',
      keyFeatures: '',
    };

    this.load();
  }

  @action
  private async load(): Promise<void> {
    try {
      const { pricelistProductFamilyDetails } = await this.client.send(
        new GetProductFamilyDetailsQuery({ pricingContext: this.pricingContext, familyId: this.data.id }),
      );
      this.setData(pricelistProductFamilyDetails);
    } catch (error) {
      Logger.error(`Unable to load product family details. Family ID: ${this.data.id}. Error: ${error}`);
    } finally {
      this.setIsLoading(false);
    }
  }

  @action
  private setData(data: PricelistProductFamilyDetailsData) {
    this.data = data;
  }

  @action
  private setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
